import { render, staticRenderFns } from "./personal-bags-info.vue?vue&type=template&id=612eabf6&"
import script from "./personal-bags-info.vue?vue&type=script&lang=js&"
export * from "./personal-bags-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports